module.exports = __webpack_public_path__ + "img/chartmuseum.51b24177.png";